import { parse as parseQuery } from 'query-string';
import { useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router';

interface UseNoteScrollOptions {
  notes: any[];
  isLoading: boolean;
}

export function useNoteScroll({ notes, isLoading }: UseNoteScrollOptions) {
  const location = useLocation();
  const isScrolledRef = useRef(false);

  const searchParams = useMemo(
    () => parseQuery(location.search),
    [location.search],
  );
  const anchor = useMemo(() => searchParams?.anchor, [searchParams?.anchor]);
  const noteId = useMemo(() => searchParams?.note, [searchParams?.note]);

  useEffect(() => {
    isScrolledRef.current = false;
  }, [anchor, noteId]);

  useEffect(() => {
    if (
      !isScrolledRef.current &&
      notes.length > 0 &&
      !isLoading &&
      (anchor || noteId) &&
      typeof (anchor || noteId) === 'string'
    ) {
      let element: HTMLElement | null = null;

      if (anchor && typeof anchor === 'string') {
        element =
          document.getElementById(anchor) ||
          document.querySelector(`.${anchor}`);
      }

      if (!element && noteId && typeof noteId === 'string') {
        element = document.getElementById(`note-${noteId}`);
      }

      if (element) {
        isScrolledRef.current = true;
        setTimeout(() => {
          element!.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        isScrolledRef.current = true;
      }
    }
  }, [anchor, noteId, isLoading, notes]);

  return { anchor, noteId };
}
